module.exports = __webpack_public_path__ + "static/media/egypt-map.0896c9b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/egypt-map.jpg
// module id = 171
// module chunks = 9